// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MenuSvg from '@rsuite/icon-font/lib/application/Menu';
var Menu = createSvgIcon({
  as: MenuSvg,
  ariaLabel: 'menu',
  category: 'application',
  displayName: 'Menu'
});
export default Menu;